"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Token =
/*#__PURE__*/
function () {
  /**
   * Create a new token and parse it
   *
   * @param token
   */
  function Token(token) {
    _classCallCheck(this, Token);

    this.token = token;

    _defineProperty(this, "decoded", null);

    try {
      this.decoded = (0, _jwtDecode.default)(token);
    } catch (e) {} // tslint:disable-line:no-empty

  }
  /**
   * Checks if a token has a valid format and isn't expired yet
   */


  _createClass(Token, [{
    key: "isValid",
    value: function isValid() {
      if (!this.decoded) {
        return false;
      }

      var expiresAt = this.decoded.exp * 1000;
      return expiresAt >= new Date().getTime();
    }
    /**
     * Return the token string
     */

  }, {
    key: "getToken",
    value: function getToken() {
      if (!this.isValid()) {
        return null;
      }

      return this.token;
    }
    /**
     * Returnt the parsed token
     */

  }, {
    key: "getParsedToken",
    value: function getParsedToken() {
      return this.decoded;
    }
    /**
     * Get the expires at timestamp in milliseconds
     */

  }, {
    key: "getExpiresAt",
    value: function getExpiresAt() {
      if (!this.decoded) {
        return 0;
      }

      return this.decoded.exp * 1000;
    }
  }]);

  return Token;
}();

exports.default = Token;